exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signup-4 .InfluencerSettingsChannelsPage {\n.ChannelCard {\n    background: #fff;\n    padding-left: 20px;\n    padding-right: 20px;\n}\nhr {\n    width: calc(100% - 40px) !important;\n}\n}\n", ""]);

// exports
